/**
 * Composable for managing periods with caching
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ref } from "vue";
import { fetchAvailablePeriods } from "./api";
// Cache storage
let periodsCache = null;
let isCacheLoaded = false;
export function usePeriods() {
    const periods = ref([]);
    const isLoading = ref(false);
    const error = ref(null);
    const loadPeriods = (table) => __awaiter(this, void 0, void 0, function* () {
        // Return cached data if available
        if (isCacheLoaded && periodsCache) {
            periods.value = periodsCache;
            return;
        }
        isLoading.value = true;
        error.value = null;
        try {
            const fetchedPeriods = yield fetchAvailablePeriods(table);
            periodsCache = fetchedPeriods;
            isCacheLoaded = true;
            periods.value = fetchedPeriods;
        }
        catch (err) {
            error.value = err;
        }
        finally {
            isLoading.value = false;
        }
    });
    const clearCache = () => {
        periodsCache = null;
        isCacheLoaded = false;
    };
    return {
        periods,
        isLoading,
        error,
        loadPeriods,
        clearCache,
    };
}
